import { Schematic } from "../../Schematic";
import { NULLABLE_SCHEMA } from "../../SchematicKind";
import { joinPackages, joinPaths } from "../../util/join";
import { KtData } from "../kotlin/KtData";
import { KtFile, ktFile } from "../kotlin/KtFile";
import { jsExport } from "../kotlin/util/annotations";
import { simpleKtName } from "../kotlin/util/simpleKtName";
import { ScaffoldingData } from "../ScaffoldingData";

export function scaffoldSchemas(schematic: Schematic, data: ScaffoldingData) {
  const fileName = joinPaths(data.currentDir, `${schematic.name}Schema.kt`);
  let file = data.files.get(fileName) as KtFile | undefined;
  if (!file) {
    data.files.set(fileName, (file = ktFile(data)));
    data.files.set(
      joinPaths(data.currentDir, `${schematic.name}Validations.kt`),
      ktFile(data),
    );
  }
  scaffoldSchemaDeclaration(schematic, { ...data, currentFile: file });
}

function scaffoldSchemaDeclaration(schematic: Schematic, data: KtData) {
  const schematicKind = data.schematicKinds.get(schematic.kind);
  if (!schematicKind) {
    throw new Error(`Unknown schematic kind ${schematic.kind}`);
  }

  const nDecls = data.currentFile.declarations.length;
  data.currentFile.declarations.push("");
  const decl = `val ${schematic.name}Schema = ${
    schematicKind.scaffoldSchema?.(schematic, data) ??
    `${simpleKtName(schematicKind.schema)}()`
  }`;
  data.currentFile.imports.add(schematicKind.schema);
  data.currentFile.declarations[nDecls] =
    data.currentPath === "/" ? jsExport(decl, data) : decl;
}

export function scaffoldSchema(schematic: Schematic, data: KtData): string {
  const schematicKind = data.schematicKinds.get(schematic.kind);
  if (!schematicKind) {
    throw new Error(`Unknown schematic kind ${schematic.kind}`);
  }

  const schematicPackage =
    schematicKind.package ??
    joinPackages(data.currentPackage, schematic.packageSuffix);

  let scaffoldedSchema: string;
  if (
    schematicKind.package == null &&
    schematicPackage !== data.currentPackage
  ) {
    scaffoldedSchema = `${schematic.name}Schema`;
    data.currentFile.imports.add(`${schematicPackage}.${scaffoldedSchema}`);
    scaffoldSchemas(schematic, {
      ...data,
      currentPackage: joinPackages(
        data.currentPackage,
        schematic.packageSuffix,
      ),
      currentDir: joinPaths(
        data.currentDir,
        schematic.packageSuffix?.replace(".", "/"),
      ),
    });
  } else {
    scaffoldedSchema =
      schematicKind.scaffoldSchema?.(schematic, data) ??
      `${simpleKtName(schematicKind.schema)}()`;
    data.currentFile.imports.add(schematicKind.schema);
  }

  if (schematic.nullable) {
    data.currentFile.imports.add(NULLABLE_SCHEMA);
    return `${simpleKtName(NULLABLE_SCHEMA)} { ${scaffoldedSchema} }`;
  }
  return scaffoldedSchema;
}
